import { AxiosPromise } from 'axios';
import { urlsConfig } from 'src/configs';
import { queryTypes, servicesYolTypes } from 'src/types';
import { urlHelper } from 'src/app/helpers';
import { axios, axiosc } from 'src/app/utils';

export const yolLookup = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
}: servicesYolTypes.YolLookupDataType): AxiosPromise<servicesYolTypes.YolLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axiosc.get(urlHelper.addQueryParameters(query, urlsConfig.generics.environment.yol), {
    blockSpinner,
  });
};

export const yolMapLookup = ({
  blockSpinner,
}: {
  blockSpinner?: boolean;
}): AxiosPromise<servicesYolTypes.YolMapLookupResultType> => {
  return axiosc.get(
    urlHelper.addQueryParameters(
      {
        isMap: 'yes',
      },
      urlsConfig.generics.environment.yol,
    ),
    {
      blockSpinner,
    },
  );
};

export const yolCreate = (
  form: servicesYolTypes.YolCreateDataType,
): AxiosPromise<servicesYolTypes.YolCreateResultType> => {
  return axiosc.post(urlsConfig.generics.environment.yol, form, { blockErrorHandler: true });
};

export const yolEdit = (form: servicesYolTypes.YolEditDataType): AxiosPromise<servicesYolTypes.YolEditResultType> => {
  return axiosc.patch(urlsConfig.generics.environment.yol, form, { blockErrorHandler: true });
};

export const yolDelete = ({
  id,
}: servicesYolTypes.YolDeleteDataType): AxiosPromise<servicesYolTypes.YolDeleteResultType> => {
  return axiosc.delete(`${urlsConfig.generics.environment.yol}/${id}`);
};
